/**
 * This code was AUTOGENERATED using the codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getBooleanDecoder,
  getBooleanEncoder,
  getDiscriminatedUnionDecoder,
  getDiscriminatedUnionEncoder,
  getI128Decoder,
  getI128Encoder,
  getI16Decoder,
  getI16Encoder,
  getI32Decoder,
  getI32Encoder,
  getI64Decoder,
  getI64Encoder,
  getI8Decoder,
  getI8Encoder,
  getStructDecoder,
  getStructEncoder,
  getTupleDecoder,
  getTupleEncoder,
  getU128Decoder,
  getU128Encoder,
  getU16Decoder,
  getU16Encoder,
  getU32Decoder,
  getU32Encoder,
  getU64Decoder,
  getU64Encoder,
  getU8Decoder,
  getU8Encoder,
  type Address,
  type Codec,
  type Decoder,
  type Encoder,
  type GetDiscriminatedUnionVariant,
  type GetDiscriminatedUnionVariantContent,
} from '@solana/kit';
import {
  getCompactBytesDecoder,
  getCompactBytesEncoder,
  type CompactBytes,
  type CompactBytesArgs,
} from '../../hooked';

export type DataValue =
  | { __kind: 'Bool'; fields: readonly [boolean] }
  | { __kind: 'U8'; fields: readonly [number] }
  | { __kind: 'I8'; fields: readonly [number] }
  | { __kind: 'U16'; fields: readonly [number] }
  | { __kind: 'I16'; fields: readonly [number] }
  | { __kind: 'U32'; fields: readonly [number] }
  | { __kind: 'I32'; fields: readonly [number] }
  | { __kind: 'U64'; fields: readonly [bigint] }
  | { __kind: 'I64'; fields: readonly [bigint] }
  | { __kind: 'U128'; fields: readonly [bigint] }
  | { __kind: 'I128'; fields: readonly [bigint] }
  | { __kind: 'Bytes'; fields: readonly [CompactBytes] }
  | { __kind: 'Pubkey'; fields: readonly [Address] };

export type DataValueArgs =
  | { __kind: 'Bool'; fields: readonly [boolean] }
  | { __kind: 'U8'; fields: readonly [number] }
  | { __kind: 'I8'; fields: readonly [number] }
  | { __kind: 'U16'; fields: readonly [number] }
  | { __kind: 'I16'; fields: readonly [number] }
  | { __kind: 'U32'; fields: readonly [number] }
  | { __kind: 'I32'; fields: readonly [number] }
  | { __kind: 'U64'; fields: readonly [number | bigint] }
  | { __kind: 'I64'; fields: readonly [number | bigint] }
  | { __kind: 'U128'; fields: readonly [number | bigint] }
  | { __kind: 'I128'; fields: readonly [number | bigint] }
  | { __kind: 'Bytes'; fields: readonly [CompactBytesArgs] }
  | { __kind: 'Pubkey'; fields: readonly [Address] };

export function getDataValueEncoder(): Encoder<DataValueArgs> {
  return getDiscriminatedUnionEncoder([
    [
      'Bool',
      getStructEncoder([['fields', getTupleEncoder([getBooleanEncoder()])]]),
    ],
    ['U8', getStructEncoder([['fields', getTupleEncoder([getU8Encoder()])]])],
    ['I8', getStructEncoder([['fields', getTupleEncoder([getI8Encoder()])]])],
    ['U16', getStructEncoder([['fields', getTupleEncoder([getU16Encoder()])]])],
    ['I16', getStructEncoder([['fields', getTupleEncoder([getI16Encoder()])]])],
    ['U32', getStructEncoder([['fields', getTupleEncoder([getU32Encoder()])]])],
    ['I32', getStructEncoder([['fields', getTupleEncoder([getI32Encoder()])]])],
    ['U64', getStructEncoder([['fields', getTupleEncoder([getU64Encoder()])]])],
    ['I64', getStructEncoder([['fields', getTupleEncoder([getI64Encoder()])]])],
    [
      'U128',
      getStructEncoder([['fields', getTupleEncoder([getU128Encoder()])]]),
    ],
    [
      'I128',
      getStructEncoder([['fields', getTupleEncoder([getI128Encoder()])]]),
    ],
    [
      'Bytes',
      getStructEncoder([
        ['fields', getTupleEncoder([getCompactBytesEncoder()])],
      ]),
    ],
    [
      'Pubkey',
      getStructEncoder([['fields', getTupleEncoder([getAddressEncoder()])]]),
    ],
  ]);
}

export function getDataValueDecoder(): Decoder<DataValue> {
  return getDiscriminatedUnionDecoder([
    [
      'Bool',
      getStructDecoder([['fields', getTupleDecoder([getBooleanDecoder()])]]),
    ],
    ['U8', getStructDecoder([['fields', getTupleDecoder([getU8Decoder()])]])],
    ['I8', getStructDecoder([['fields', getTupleDecoder([getI8Decoder()])]])],
    ['U16', getStructDecoder([['fields', getTupleDecoder([getU16Decoder()])]])],
    ['I16', getStructDecoder([['fields', getTupleDecoder([getI16Decoder()])]])],
    ['U32', getStructDecoder([['fields', getTupleDecoder([getU32Decoder()])]])],
    ['I32', getStructDecoder([['fields', getTupleDecoder([getI32Decoder()])]])],
    ['U64', getStructDecoder([['fields', getTupleDecoder([getU64Decoder()])]])],
    ['I64', getStructDecoder([['fields', getTupleDecoder([getI64Decoder()])]])],
    [
      'U128',
      getStructDecoder([['fields', getTupleDecoder([getU128Decoder()])]]),
    ],
    [
      'I128',
      getStructDecoder([['fields', getTupleDecoder([getI128Decoder()])]]),
    ],
    [
      'Bytes',
      getStructDecoder([
        ['fields', getTupleDecoder([getCompactBytesDecoder()])],
      ]),
    ],
    [
      'Pubkey',
      getStructDecoder([['fields', getTupleDecoder([getAddressDecoder()])]]),
    ],
  ]);
}

export function getDataValueCodec(): Codec<DataValueArgs, DataValue> {
  return combineCodec(getDataValueEncoder(), getDataValueDecoder());
}

// Data Enum Helpers.
export function dataValue(
  kind: 'Bool',
  data: GetDiscriminatedUnionVariantContent<
    DataValueArgs,
    '__kind',
    'Bool'
  >['fields']
): GetDiscriminatedUnionVariant<DataValueArgs, '__kind', 'Bool'>;
export function dataValue(
  kind: 'U8',
  data: GetDiscriminatedUnionVariantContent<
    DataValueArgs,
    '__kind',
    'U8'
  >['fields']
): GetDiscriminatedUnionVariant<DataValueArgs, '__kind', 'U8'>;
export function dataValue(
  kind: 'I8',
  data: GetDiscriminatedUnionVariantContent<
    DataValueArgs,
    '__kind',
    'I8'
  >['fields']
): GetDiscriminatedUnionVariant<DataValueArgs, '__kind', 'I8'>;
export function dataValue(
  kind: 'U16',
  data: GetDiscriminatedUnionVariantContent<
    DataValueArgs,
    '__kind',
    'U16'
  >['fields']
): GetDiscriminatedUnionVariant<DataValueArgs, '__kind', 'U16'>;
export function dataValue(
  kind: 'I16',
  data: GetDiscriminatedUnionVariantContent<
    DataValueArgs,
    '__kind',
    'I16'
  >['fields']
): GetDiscriminatedUnionVariant<DataValueArgs, '__kind', 'I16'>;
export function dataValue(
  kind: 'U32',
  data: GetDiscriminatedUnionVariantContent<
    DataValueArgs,
    '__kind',
    'U32'
  >['fields']
): GetDiscriminatedUnionVariant<DataValueArgs, '__kind', 'U32'>;
export function dataValue(
  kind: 'I32',
  data: GetDiscriminatedUnionVariantContent<
    DataValueArgs,
    '__kind',
    'I32'
  >['fields']
): GetDiscriminatedUnionVariant<DataValueArgs, '__kind', 'I32'>;
export function dataValue(
  kind: 'U64',
  data: GetDiscriminatedUnionVariantContent<
    DataValueArgs,
    '__kind',
    'U64'
  >['fields']
): GetDiscriminatedUnionVariant<DataValueArgs, '__kind', 'U64'>;
export function dataValue(
  kind: 'I64',
  data: GetDiscriminatedUnionVariantContent<
    DataValueArgs,
    '__kind',
    'I64'
  >['fields']
): GetDiscriminatedUnionVariant<DataValueArgs, '__kind', 'I64'>;
export function dataValue(
  kind: 'U128',
  data: GetDiscriminatedUnionVariantContent<
    DataValueArgs,
    '__kind',
    'U128'
  >['fields']
): GetDiscriminatedUnionVariant<DataValueArgs, '__kind', 'U128'>;
export function dataValue(
  kind: 'I128',
  data: GetDiscriminatedUnionVariantContent<
    DataValueArgs,
    '__kind',
    'I128'
  >['fields']
): GetDiscriminatedUnionVariant<DataValueArgs, '__kind', 'I128'>;
export function dataValue(
  kind: 'Bytes',
  data: GetDiscriminatedUnionVariantContent<
    DataValueArgs,
    '__kind',
    'Bytes'
  >['fields']
): GetDiscriminatedUnionVariant<DataValueArgs, '__kind', 'Bytes'>;
export function dataValue(
  kind: 'Pubkey',
  data: GetDiscriminatedUnionVariantContent<
    DataValueArgs,
    '__kind',
    'Pubkey'
  >['fields']
): GetDiscriminatedUnionVariant<DataValueArgs, '__kind', 'Pubkey'>;
export function dataValue<K extends DataValueArgs['__kind'], Data>(
  kind: K,
  data?: Data
) {
  return Array.isArray(data)
    ? { __kind: kind, fields: data }
    : { __kind: kind, ...(data ?? {}) };
}

export function isDataValue<K extends DataValue['__kind']>(
  kind: K,
  value: DataValue
): value is DataValue & { __kind: K } {
  return value.__kind === kind;
}
